<template>
  <div class="process-info">
    <md-chip :class="`macro-${(process.color || DEFAULT_COLOR).replace(' ', '-')}`" class="process-chip">
      <h6> <strong> {{process.name}} </strong> </h6>
    </md-chip>
    <template  v-if="process.processInfo != null">
    

      <p>
        <div class="sorf-column category">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-40">
              <strong>Responsable</strong>
            </div>
            <div class="md-layout-item md-size-60">
              <span> {{ process.processInfo.responsable }}</span>
            </div>
          </div>
        </div>
        <div class="sorf-column category">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-40">
              <strong>Inicio</strong>
            </div>
            <div class="md-layout-item md-size-60">
              <span> {{ process.processInfo.inicio }} </span>
            </div>
          </div>
        </div>
        <div class="sorf-column category">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-40">
              <strong>Indicador</strong>
            </div>
            <div class="md-layout-item md-size-60">
              <span> {{ process.processInfo.indicador }} </span>
            </div>
          </div>
        </div>
        <div class="sorf-column category">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-40">
              <strong>Proceso</strong>
            </div>
            <div class="md-layout-item md-size-60">
              <span> {{ process.processInfo.proceso }} </span>
            </div>
          </div>
        </div>
        <div class="sorf-column category">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-40">
              <strong>Final</strong>
            </div>
            <div class="md-layout-item md-size-60">
              <span> {{ process.processInfo.final }} </span>
            </div>
          </div>
        </div>
        <md-divider></md-divider>
      </p>

    </template>

    <loading-content v-else class="tooltip-empty-state"
    empty-icon="info"
    empty-label=""
    empty-description="No hay información disponible."/>
  </div>
</template>

<script>
export default {

  name: 'ProcessInfo',

  props: {
    process: {
      type: Object,
      required: true,
    }
  },

  data () {
    return {
      vertical: 'center',
      horizontal: 'center',
      DEFAULT_COLOR: 'red'
    }
  },
  beforeMount () {
    if (this.process.proccess_info) {
      var objeto = JSON.parse(this.process.proccess_info);
      this.process.processInfo = objeto
    }
  }
}
</script>

<style lang="css" scoped>

.md-empty-state.loadable-content.tooltip-empty-state {
  margin: 5px 5px 5px 5px;
  padding: 5px 5px 5px 5px;
}

.md-chip.process-chip {
  padding-bottom: 5px;
  height: 30px;
  line-height: 30px;
}

.category{
  width: 120%;
  text-align: left;
  padding-left: 15px;
  padding-right: 20px;
}

.process-info{
  justify-content: center;
  display: grid;
  text-align: center;
}
  .md-layout {
    transition: .3s $md-transition-stand-timing;
  }

  .sorf-column .md-layout-item {
    min-height: 40px;
    transition: .3s $md-transition-stand-timing;

    span {
      width: 100%;
      height: 100%;
      padding: 0px;
      display: block;
      background: md-get-palette-color(blue, 200);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Macro/ProcessInfo.vue